export const TABLECOLUMN = [
  {
    label: '货主编码',
    prop: 'code',
    width: 180,
  },
  {
    label: '企业名称',
    prop: 'name',
    width: 180,
  },
  {
    label: '联系人信息',
    prop: 'info',
    width: 180,
    formatter: (row) => `${row.customerInfo?.contacts || ''} ${row.customerInfo?.telPhone || ''}`,
  },
  {
    label: '联系人地址',
    prop: 'address',
    width: 220,
    formatter: (row) => `${row.customerInfo?.provinceName || ''}${row.customerInfo?.cityName || ''}${row.customerInfo?.countyName || ''}${row.customerInfo?.address || ''}`,
  },
];

export const BINDTYPE = {
  NONE: 'NONE',
  PARENT: 'PARENT',
  CHILDREN: 'CHILDREN',
};

export const TYPE = 'ORG';

export const STATUS = {
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
};

export const ASCRIPTION_TYPE = {
  SELF_EMPLOYED: '自营',
  JOIN: '加盟',
};
export const FILE_TYPE = {
  IMAGE: 'image',
  VIDEO: 'video',
};
export const RECEIVING = [
  {
    thermosphere: '恒温',
    time: '06:00-12:00',
  },
  {
    thermosphere: '常温/冷冻',
    time: '06:00-12:00',
  },
];
export const DICTIONARY = {
  NORMAL: 'NORMAL',
};
export const TagType = ['success', 'info', 'warning', 'danger'];
